// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resident-group-table-component .delete-btn[data-v-668f8ee2],.resident-group-table-component .edit-btn[data-v-668f8ee2],.resident-group-table-component .list-btn[data-v-668f8ee2]{width:64px}.resident-group-table-component .list-btn[data-v-668f8ee2],.resident-group-table-component .operation .edit-btn[data-v-668f8ee2]{margin-right:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
